import { getLanguageConfig } from '../config/languages';

/**
 * 言語に応じて適切な見出しフォントクラスを返す関数
 * @param {string} locale - 現在の言語設定
 * @returns {string} - 適切なフォントクラス名
 */
export const getHeadingFontClass = locale => {
  const config = getLanguageConfig(locale);
  return config.headingFontClass;
};

/**
 * 言語に応じて適切な基本フォントクラスを返す関数（旧getBodyFontClass）
 * @param {string} locale - 現在の言語設定
 * @returns {string} - 適切なフォントクラス名
 */
export const getFontClass = locale => {
  const config = getLanguageConfig(locale);
  return config.fontClass;
};

/**
 * 言語に応じて適切なボディフォントクラスを返す関数（後方互換性）
 * @param {string} locale - 現在の言語設定
 * @returns {string} - 適切なフォントクラス名
 * @deprecated getFontClassを使用してください
 */
export const getBodyFontClass = locale => {
  return getFontClass(locale);
};

/**
 * 言語に応じて適切なセリフフォントクラスを返す関数（後方互換性）
 * @param {string} locale - 現在の言語設定
 * @returns {string} - 適切なフォントクラス名
 * @deprecated getHeadingFontClassを使用してください
 */
export const getSerifFontClass = locale => {
  return getHeadingFontClass(locale);
};
